import words from './words';

export default {
  words
};
